/* SUKI edge animation: baked halftone flower (exported from BINARY), trimmed to the halftone path.
   Renders each frame once to an offscreen canvas and copies it to every visible .suki-edge__canvas.
   Frames live in suki-edge-anim-frames.webp (48 greyscale frames in an 8x6 sprite sheet) and are loaded only when an instance nears the viewport. */
(function () {
  if (window.SukiEdge) { window.SukiEdge.scan(); return; }

  var TAU = Math.PI * 2;
  var IW = 1280, IH = 720, COLS = 140, FPS = 12, BAKE_FPS = 7.5;
  var BW = 420, BH = 236, FRAMES = 48, SHEET_COLS = 8, FRAME_BYTES = BW * BH;
  var SCALE = 0.75, CW = Math.round(IW * SCALE), CH = Math.round(IH * SCALE);
  var LATTICE = Math.PI / 4, PITCH = IW / COLS;
  var STAR_CUT = 0.8, STAR_SCATTER = 0.02, STAR_SCALE = 1.7, MIN_S = 0, MAX_S = 1.02, CURVE = 2.1;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function hash2(i, j) { var h = i * 374761393 + j * 668265263; h = (h ^ (h >> 13)) * 1274126177; return ((h ^ (h >> 16)) >>> 0) / 4294967296; }

  var starPath = (function () {
    var p = new Path2D(), n = 4, depth = 0.3, first = true;
    for (var i = 0; i < n; i++) {
      var a = i * TAU / n - Math.PI / 2, b = a + Math.PI / n;
      var pts = [[Math.cos(a), Math.sin(a)], [Math.cos(b) * depth, Math.sin(b) * depth]];
      for (var k = 0; k < 2; k++) { if (first) { p.moveTo(pts[k][0], pts[k][1]); first = false; } else p.lineTo(pts[k][0], pts[k][1]); }
    }
    p.closePath();
    return p;
  })();

  var off = document.createElement('canvas');
  off.width = CW; off.height = CH;
  var octx = off.getContext('2d');

  var frames = null, lastIdx = -1, lum = null;
  var items = [];
  var playing = false, lastT = 0, tick = 0, loading = false;

  function decode(img) {
    var c = document.createElement('canvas');
    c.width = img.naturalWidth; c.height = img.naturalHeight;
    var g = c.getContext('2d', { willReadFrequently: true });
    g.drawImage(img, 0, 0);
    var px = g.getImageData(0, 0, c.width, c.height).data;
    frames = [];
    for (var f = 0; f < FRAMES; f++) {
      var fx = (f % SHEET_COLS) * BW, fy = Math.floor(f / SHEET_COLS) * BH, out = new Uint8Array(FRAME_BYTES);
      for (var y = 0; y < BH; y++) {
        var src = ((fy + y) * c.width + fx) * 4, dst = y * BW;
        for (var x = 0; x < BW; x++) out[dst + x] = px[src + x * 4];
      }
      frames.push(out);
    }
  }

  function bilinear(x, y) {
    var fx = x / IW * BW - 0.5, fy = y / IH * BH - 0.5;
    var x0 = Math.floor(fx), y0 = Math.floor(fy), tx = fx - x0, ty = fy - y0;
    var x1 = clamp(x0 + 1, 0, BW - 1), y1 = clamp(y0 + 1, 0, BH - 1);
    x0 = clamp(x0, 0, BW - 1); y0 = clamp(y0, 0, BH - 1);
    var a = lum[y0 * BW + x0], b = lum[y0 * BW + x1], c = lum[y1 * BW + x0], d = lum[y1 * BW + x1];
    return ((a + (b - a) * tx) * (1 - ty) + (c + (d - c) * tx) * ty) / 255;
  }

  function paint(color) {
    octx.setTransform(1, 0, 0, 1, 0, 0);
    octx.clearRect(0, 0, CW, CH);
    octx.fillStyle = color;

    var cosT = Math.cos(LATTICE), sinT = Math.sin(LATTICE);
    var umin = 1e12, umax = -1e12, vmin = 1e12, vmax = -1e12;
    [[0, 0], [IW, 0], [0, IH], [IW, IH]].forEach(function (c) {
      var u = c[0] * cosT + c[1] * sinT, v = -c[0] * sinT + c[1] * cosT;
      if (u < umin) umin = u; if (u > umax) umax = u; if (v < vmin) vmin = v; if (v > vmax) vmax = v;
    });
    var i0 = Math.floor(umin / PITCH) - 1, i1 = Math.ceil(umax / PITCH) + 1;
    var j0 = Math.floor(vmin / PITCH) - 1, j1 = Math.ceil(vmax / PITCH) + 1;

    for (var j = j0; j <= j1; j++) {
      var v = j * PITCH;
      for (var i = i0; i <= i1; i++) {
        var u = i * PITCH, x = u * cosT - v * sinT, y = u * sinT + v * cosT;
        if (x < 0 || x >= IW || y < 0 || y >= IH) continue;
        var t = bilinear(x, y);
        if (t < 0.004) continue;
        var f = MIN_S + (MAX_S - MIN_S) * Math.pow(t, CURVE);
        var star = t >= STAR_CUT || hash2(i + 7919, j + 104729) < STAR_SCATTER;
        if (star) f *= STAR_SCALE * (1 + 0.7 * Math.pow(t, 6));
        var R = f * PITCH / 2;
        if (R < 0.03) continue;
        var X = x * SCALE, Y = y * SCALE, r = R * SCALE;
        if (star) {
          var co = cosT * r, si = sinT * r;
          octx.setTransform(co, si, -si, co, X, Y);
          octx.fill(starPath);
        } else {
          octx.setTransform(1, 0, 0, 1, 0, 0);
          octx.beginPath(); octx.arc(X, Y, r, 0, TAU); octx.fill();
        }
      }
    }
    octx.setTransform(1, 0, 0, 1, 0, 0);
  }

  function isShown(it) { return it.visible && it.canvas.getClientRects().length > 0; }

  function draw() {
    var idx = Math.floor(tick * BAKE_FPS) % FRAMES;
    if (idx !== lastIdx) { lastIdx = idx; lum = frames[idx]; paint(current.color); }
    items.forEach(function (it) {
      if (!isShown(it)) return;
      it.ctx.clearRect(0, 0, CW, CH);
      it.ctx.drawImage(off, 0, 0);
    });
  }

  var current = { color: '#D2DE26' };

  function loop(t) {
    if (!playing) return;
    if (!items.some(isShown)) { playing = false; return; }
    if (t - lastT >= 1000 / FPS) { lastT = t; tick += 1 / FPS; draw(); }
    requestAnimationFrame(loop);
  }

  function play() {
    if (!frames || playing) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { draw(); return; }
    playing = true;
    requestAnimationFrame(loop);
  }

  function load(url) {
    if (frames) return play();
    if (loading) return;
    loading = true;
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () { decode(img); draw(); play(); };
    img.onerror = function () { loading = false; };
    img.src = url;
  }

  function scan() {
    document.querySelectorAll('.suki-edge__canvas:not([data-ready])').forEach(function (canvas) {
      canvas.setAttribute('data-ready', '');
      canvas.width = CW; canvas.height = CH;
      var root = canvas.closest('.suki-edge');
      var it = { canvas: canvas, ctx: canvas.getContext('2d'), visible: false };
      items.push(it);
      if (root && root.dataset.color) current.color = root.dataset.color;
      var url = root && root.dataset.bake;
      if (!('IntersectionObserver' in window)) { it.visible = true; if (url) load(url); return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          it.visible = e.isIntersecting;
          if (e.isIntersecting && url) { if (frames) { draw(); play(); } else load(url); }
        });
      }, { rootMargin: '300px 0px' }).observe(canvas);
    });
  }

  window.SukiEdge = { scan: scan };
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
